import React from "react";
import { Progress } from "antd";
import "./ProgressCircle.css";

const ProgressCircle = ({ percentCircle, width, isActive }) => {
  return (
    <div className={`progress-text-container ${isActive ? 'active' : ''}`}>
      <Progress
        className="my-progress-circle"
        type="circle"
        percent={percentCircle}
        strokeColor="#00DD9E"
        width={width}
        strokeWidth={8}
      />
    </div>
  );
};

export default ProgressCircle;